// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uStgz","icon":"styles_icon__3TB8d"};